import React from 'react';
import { Button } from 'react-bootstrap';

import '../css/Chat.css';  // Custom styles for the chat component

const ChatHeader = ({ onClose }) => {
  return (
    <div className="chat-header">
      <h5>Present-Bot</h5>
      <Button variant="outline-light" size="sm" onClick={onClose}>
        Close
      </Button>
    </div>
  );
};

export default ChatHeader;